import React, { useContext, useState, useEffect, useRef } from "react";
import "./CreatProject.css";
import Application from "../../../StateContext/Application.js";
import CustomDateTimePicker from "../CustomDateTimePicker.jsx";
import { useNavigate, useLocation ,useParams} from "react-router-dom";
import Select from "react-select";
import { apiurl } from "../../../../../path"; 

import {
  ProjectCreation64,
  BudgetHeadCreationBlue32,
  Cancel32,
  DeleteRed32,
  EditBlueBlue32,
  submit,
  Tax32,
  UpdateWhite32,
  EditIcon,
  DeleteIcon,
  Edit32WHITE,
  Delete32WHITE,
} from "../../../../../public/LoginImages/importimages";
let tempGRFile = null;



// 27-10 for cal
const pad = (n) => String(n).padStart(2, "0");

const toLocalInput = (value) => {
  if (!value) return "";
  const d =
    value instanceof Date ? value : new Date(String(value).replace(" ", "T"));
  if (isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const getCurrentDateTime = () => toLocalInput(new Date());

const CreateProject = ({
  isEdit: isEditProp = false,
  projectData,
  onSuccess,
  onCancel,
}) => {
  const { id: urlProjectId } = useParams();

  // URL me :id hai ya prop se edit aaya -> edit mode
  const isEdit = isEditProp || !!urlProjectId;

  const currentProjectId =
    projectData?.ProjectId || projectData?.ProjectID || urlProjectId || null;
  console.log("Received Project Data:", projectData);
  const operation = useContext(Application);
  const {
    ProjectCreation,
    GetBudgetHeadInfo,
    GetAgencyList,
    CreateMapCoordinateforProject,
  } = operation;
  const [allHeads, setAllHeads] = useState([]);
  const [selectedHead, setSelectedHead] = useState("");
  const [Agency, setAgency] = useState([]);
  const [selectedAgency, setSelectedAgency] = useState(null);

  const [allowSessionSave, setAllowSessionSave] = useState(true);
  const grCopyRef = useRef(null);
  const [grCopyName, setGrCopyName] = useState("");
  // get current date-time in "YYYY-MM-DDTHH:MM" format
  const getMinDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  const [schemeType, setSchemeType] = useState("");
  const minDateTime = getMinDateTime();
 //22-09 mapedit
const restoredFromMapRef = useRef(false); //22-09 mapedit
  const [data, setData] = useState({
    ProjectId: "",
    FinancialYear: "",
    ProjectName: "",
    Projectdetail: "",
    piu: "",
    ProjectCost: "",
    ProjectEstimationCompletionDate: "",
    GRNumber: "",
    GRDate: "",
    Scheme: "",
    SchemeType: "",
    GRCopy: "",
  });

  const [loading, setLoading] = useState(false);

  const [diableChoosebutton, setDiableChoosebutton] = useState(false);
  const [locationData, setLocationData] = useState({
    // latitude: "",
    // longitude: "",
    StartCoordinates: [],
    EndCoordinates: [],
    PolygonCoordinates: [],
  });

  const navigate = useNavigate();
  const nav = useNavigate();
  const location = useLocation();
  // ---- Restore form fields + location data after returning from the map page ----
  useEffect(() => {
    
    // 22-09 mapedit
    const returningFromMap =
  isEdit &&
  currentProjectId &&
  sessionStorage.getItem("MapProjectId") === String(currentProjectId);
 
if (isEdit && !returningFromMap) return;

const keepFlag =
  sessionStorage.getItem("ProjectMapReturnMode") === "create";


if (!isEdit && !keepFlag) {
  restoredFromMapRef.current = false;
  tempGRFile = null;
  [
    "ProjectForm",
    "ProjectMapLocation",
    "SelectedHead",
    "SelectedAgency",
    "GRCopyName",
    "ProjectTempData",
    "MapProjectId",
  ].forEach((k) => sessionStorage.removeItem(k));

  setData({
    ProjectId: "",
    FinancialYear: "",
    ProjectName: "",
    Projectdetail: "",
    piu: "",
    ProjectCost: "",
    ProjectEstimationCompletionDate: "",
    GRNumber: "",
    GRDate: "",
    Scheme: "",
    SchemeType: "",
    GRCopy: "",
  });
  setGrCopyName("");
  setSelectedHead("");
  setSelectedAgency(null);
  setLocationData({
    StartCoordinates: [],
    EndCoordinates: [],
    PolygonCoordinates: [],
  });
  setDiableChoosebutton(false);
  if (grCopyRef.current) grCopyRef.current.value = "";
  return;
}

if (returningFromMap) restoredFromMapRef.current = true;
// ---------
    const savedForm = sessionStorage.getItem("ProjectForm");
    console.log("RESTORE PROJECT FORM:", savedForm);
    const savedLocation = sessionStorage.getItem("ProjectMapLocation");
    const savedHead = sessionStorage.getItem("SelectedHead");
    const savedAgency = sessionStorage.getItem("SelectedAgency");
    const savedGRCopyName = sessionStorage.getItem("GRCopyName");

    console.log("RESTORE PROJECT FORM:", savedForm);
    console.log("RESTORE GR COPY:", savedGRCopyName);

    if (savedForm) {
      const parsedForm = JSON.parse(savedForm);

      setData({
        ...parsedForm,
        GRCopy: parsedForm.GRCopy || "",
      });

      if (parsedForm.GRCopy) {
        setGrCopyName(parsedForm.GRCopy);
      }
    }

    if (savedGRCopyName) {
      setGrCopyName(savedGRCopyName);

      // Keep filename in form state also
      setData((prev) => ({
        ...prev,
        GRCopy: savedGRCopyName,
      }));
      if (tempGRFile && grCopyRef.current) {
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(tempGRFile);
        grCopyRef.current.files = dataTransfer.files;
      }
    }

    if (savedForm) {
      setData(JSON.parse(savedForm));
    }

    if (savedHead) {
      setSelectedHead(JSON.parse(savedHead));
    }

    if (savedAgency) {
      setSelectedAgency(JSON.parse(savedAgency));
    }

    if (savedLocation) {
      const parsed = JSON.parse(savedLocation);
      setLocationData(parsed);
      setDiableChoosebutton(
        parsed?.StartCoordinates?.length > 0 &&
          parsed?.EndCoordinates?.length > 0,
      );
    }
  // }, [isEdit, location.pathname]); 22-09  mapedit
 }, [isEdit, currentProjectId, location.pathname]);

  // ---- If editing, fetch existing saved coordinates for this ProjectId ----
  // useEffect(() => {
  //   const fetchExisting = async () => {
  //     if (isEdit && projectData?.ProjectId && CreateMapCoordinateforProject) {
  //       try {
  //         console.log("Location Data =", locationData);
  //         console.log({
  //           start: locationData.StartCoordinates,
  //           end: locationData.EndCoordinates,
  //           polygon: locationData.PolygonCoordinates,
  //         });
  //         const res = await CreateMapCoordinateforProject(
  //           "FetchCoordinateForProject",
  //           projectData.ProjectId,
  //         );
  //         if (res) {
  //           console.log("result---", res);
  //           setLocationData({
  //             StartCoordinates: res.StartCoordinates || [],
  //             EndCoordinates: res.EndCoordinates || [],
  //             PolygonCoordinates: res.Area || [],
  //           });
  //           setDiableChoosebutton(true);
  //         }
  //       } catch (err) {
  //         console.log("Fetch existing coordinates error:", err);
  //       }
  //     }
  //   };
  //   fetchExisting();
  // }, [isEdit, projectData]);

  // 22-09 mapedit
useEffect(() => {

  const fetchExisting = async () => {
if (!isEdit || !currentProjectId || !CreateMapCoordinateforProject) return;


    const returningFromMap =

   sessionStorage.getItem("MapProjectId") === String(currentProjectId) &&

      sessionStorage.getItem("ProjectMapLocation");

    if (returningFromMap) return;
 
    try {

      const res = await CreateMapCoordinateforProject(

      "FetchCoordinateForProject",
currentProjectId,

      );

      if (res) {

        setLocationData({

          StartCoordinates: res.StartCoordinates || [],

          EndCoordinates: res.EndCoordinates || [],

          PolygonCoordinates: res.Area || [],

        });

        setDiableChoosebutton(true);

      }

    } catch (err) {

      console.log("Fetch existing coordinates error:", err);

    }

  };

  fetchExisting();

}, [isEdit, projectData]);
//  -------

  // useEffect(() => {
  //   if (isEdit && projectData?.HeadID && allHeads.length > 0) {
  //     const matchedHead = allHeads.find((h) => h.HeadID === projectData.HeadID);
  //     if (matchedHead) {
  //       setSelectedHead(matchedHead);
  //     }
  //   }
  // }, [isEdit, projectData, allHeads]);

  // 09-10 agnecy undefind
    useEffect(() => {
    if (isEdit && projectData?.HeadID && allHeads.length > 0) {
      const matchedHead = allHeads.find((h) => h.HeadID === projectData.HeadID);
      if (matchedHead) {
        setSelectedHead(matchedHead);
      }
    }
  }, [isEdit, projectData, allHeads]);
 
  // ---- Continuously persist form fields as the user types, so a raw refresh doesn't lose them ----
  useEffect(() => {
    if (isEdit) return;
    if (data.ProjectName || data.ProjectCost || data.FinancialYear) {
      const sessionData = {
        ...data,
        GRCopy:
          grCopyName || (typeof data.GRCopy === "string" ? data.GRCopy : ""),
      };

      sessionStorage.setItem("ProjectForm", JSON.stringify(data));
    }
  }, [data, grCopyName, isEdit]);

  useEffect(() => {
    if (locationData.StartCoordinates.length > 0) {
      sessionStorage.setItem(
        "ProjectMapLocation",
        JSON.stringify(locationData),
      );
    }
  }, [locationData]);

  const navigatetoMap = (e) => {
    e.preventDefault();
  sessionStorage.setItem("keepProjectForm", "true"); // original, dusre components ke liye
sessionStorage.setItem("ProjectMapReturnMode", isEdit ? "edit" : "create"); // sirf is component ke liye
    if (grCopyRef.current?.files?.[0]) {
      const fileName = grCopyRef.current.files[0].name;

      setGrCopyName(fileName);

      sessionStorage.setItem("GRCopyName", fileName);
    }
    // Save form data WITHOUT File object
    const formDataForSession = {
      ...data,
      GRCopy:
        grCopyRef.current?.files?.[0]?.name ||
        grCopyName ||
        (typeof data.GRCopy === "string" ? data.GRCopy : ""),
    };
    // Save form data
    sessionStorage.setItem("ProjectForm", JSON.stringify(formDataForSession));
    // Save selected agency
    sessionStorage.setItem("SelectedAgency", JSON.stringify(selectedAgency));
    sessionStorage.setItem("SelectedHead", JSON.stringify(selectedHead));
    // Save all IDs
    sessionStorage.setItem(
      "ProjectTempData",
      JSON.stringify({
       ProjectId: currentProjectId || null,
        HeadID: selectedHead?.HeadID || null,
        AgencyCode: data.piu,
        AgencyID: selectedAgency?.AgencyID || null,
        ProjectName: data.ProjectName,
      }),
    );

    // EDIT PROJECT
  if (isEdit && currentProjectId) {
  sessionStorage.setItem("MapProjectId", currentProjectId);
  navigate(`/AdminDashboard/MapFunction/${currentProjectId}`);
}
    // NEW PROJECT
    else {
      sessionStorage.removeItem("MapProjectId");
      navigate("/AdminDashboard/MapFunction");
    }
  };

  const HandleChangeData = (e) => {
    const { name, value, files } = e.target;
    // 30-09
//     if (
//   name === "GRDate" ||
//   name === "ProjectEstimationCompletionDate"
// ) {
//   // 01-10
//   setTimeout(() => {
//     e.target.blur();
//   }, 0);
//   const year = value.split("-")[0];
 
//   // Block 5 or more digit year
//   if (year.length > 4) {
//     return;
//   }
 
//   // Only numeric year
//   if (year && !/^\d{1,4}$/.test(year)) {
//     return;
//   }
// }
// 24-10 for cal
if (name === "GRDate" || name === "ProjectEstimationCompletionDate") {
  if (value) {
    const year = value.split("-")[0];
    if (year.length > 4 || !/^\d{1,4}$/.test(year)) {
      return;
    }
  }
}
// -----------

    if (name === "GRCopy" && files && files.length > 0) {
      const selectedFile = files[0];
      tempGRFile = selectedFile;
      // Keep actual File object in React state
      setData((prev) => ({
        ...prev,
        GRCopy: selectedFile,
      }));

      // Keep filename separately
      setGrCopyName(selectedFile.name);

      // Store filename in session
      sessionStorage.setItem("GRCopyName", selectedFile.name);

      // Store other form data + filename, NOT File object
      const currentForm = {
        ...data,
        GRCopy: selectedFile.name,
      };

      sessionStorage.setItem("ProjectForm", JSON.stringify(currentForm));

      return;
    }

    const updatedData = {
      ...data,
      [name]: value,
    };

    setData(updatedData);

    // Preserve GR Copy filename if already selected
    const sessionData = {
      ...updatedData,
      GRCopy:
        grCopyName ||
        (typeof updatedData.GRCopy === "string" ? updatedData.GRCopy : ""),
    };

    sessionStorage.setItem("ProjectForm", JSON.stringify(sessionData));
  };
 // 27-10
const handleDateTimeChange = (e) => {
  const input = e.target;
  const name = input.name;
  let value = input.value;

  const prevDate = toLocalInput(data[name]).split("T")[0];
  let newDate = (value || "").split("T")[0];

  // Minimum allowed value for this field
  const minValue =
    name === "ProjectEstimationCompletionDate"
      ? toLocalInput(data.GRDate) || getCurrentDateTime()
      : getCurrentDateTime();

  // If the picked date equals the minimum date, make sure the time
  // is not earlier than the minimum (avoids an invalid past time).
  if (value && newDate === minValue.split("T")[0] && value < minValue) {
    value = minValue;
  }

  HandleChangeData({ target: { name, value } });

  if (!newDate) return;

  // If the field was empty, compare against the date the picker opens on
  const baseline = prevDate || minValue.split("T")[0];

  const [py, pm, pd] = baseline.split("-").map(Number);
  const [ny, nm, nd] = newDate.split("-").map(Number);

  const monthChanged = py !== ny || pm !== nm;
  const daysInNewMonth = new Date(ny, nm, 0).getDate();

  // Month arrows keep the same day (or clamp it, e.g. 31 -> 30)
  const isArrowNavigation =
    monthChanged &&
    (pd === nd || (nd === daysInNewMonth && pd > daysInNewMonth));

  // Only the time was changed (same date as before)
  const isTimeOnly = prevDate && newDate === prevDate;

  // Close only when a date was actually clicked
  if (!isArrowNavigation && !isTimeOnly) {
    setTimeout(() => input.blur(), 0);
  }
};
  const formData = new FormData();
  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("========== SUBMIT PROJECT ==========");
    console.log("isEdit:", isEdit);
    console.log("projectData:", projectData);
    console.log("data:", data);

    setLoading(true);

    try {
      // ============================================================
      // CREATE NEW FormData EVERY TIME
      // ============================================================
      const formData = new FormData();

      // ============================================================
      // GET FILE
      // ============================================================
    const file = grCopyRef.current?.files?.[0] || tempGRFile || null;

      // ============================================================
      // COMMON VALIDATION
      // ============================================================
      if (!data.FinancialYear) {
        alert("Please select Financial Year");
        setLoading(false);
        return;
      }

      if (!data.Scheme) {
        alert("Please select Scheme");
        setLoading(false);
        return;
      }

      if (!data.ProjectName?.trim()) {
        alert("Please enter Project Name");
        setLoading(false);
        return;
      }

      if (!data.Projectdetail?.trim()) {
        alert("Please enter Project Details");
        setLoading(false);
        return;
      }

      if (!data.piu) {
        alert("Please select Implementing Agency");
        setLoading(false);
        return;
      }

      if (!data.ProjectCost) {
        alert("Please enter Project Cost");
        setLoading(false);
        return;
      }

      if (!data.ProjectEstimationCompletionDate) {
        alert("Please select Project Estimation Completion Date");
        setLoading(false);
        return;
      }

      if (!data.GRNumber) {
        alert("Please enter GR Number");
        setLoading(false);
        return;
      }

      if (!data.GRDate) {
        alert("Please select GR Date");
        setLoading(false);
        return;
      }

      // ============================================================
      // GR COPY
      //
      // CREATE:
      //   New file is compulsory
      //
      // EDIT:
      //   Existing DB file is enough.
      //   New file is optional.
      // ============================================================
      if (!isEdit && !file) {
        alert("Please select GR Copy");
        setLoading(false);
        return;
      }

      // ============================================================
      // AREA VALIDATION
      // ============================================================
      if (
        !locationData?.StartCoordinates?.length ||
        !locationData?.EndCoordinates?.length
      ) {
        alert("Please Choose Area first!");
        setLoading(false);
        return;
      }

      // ============================================================
      // BUDGET HEAD
      // ============================================================
      if (data.Scheme === "Budget" && !selectedHead) {
        alert("Please select Budget Head");
        setLoading(false);
        return;
      }

      // ============================================================
      // APPEND FORM FIELDS
      // ============================================================
      formData.append("FinancialYear", data.FinancialYear || "");

      formData.append("ProjectName", data.ProjectName || "");

      formData.append("Projectdetail", data.Projectdetail || "");

      formData.append("piu", data.piu || "");

      formData.append("ProjectCost", data.ProjectCost || "");

      formData.append(
        "ProjectEstimationCompletionDate",
        data.ProjectEstimationCompletionDate || "",
      );

      formData.append("GRNumber", data.GRNumber || "");

      formData.append("GRDate", data.GRDate || "");

      formData.append("Scheme", data.Scheme || "");

      // ============================================================
      // PROJECT ID
      // ============================================================
    if (isEdit) {
  formData.append("ProjectId", currentProjectId || data.ProjectId || "");
}

      // ============================================================
      // HEAD DATA
      // ============================================================
      formData.append(
        "HeadID",
        selectedHead?.HeadID || projectData?.HeadID || "N/A",
      );

      formData.append(
        "HeadName",
        selectedHead?.HeadName || projectData?.HeadName || "N/A",
      );

      formData.append(
        "ObjectCode",
        selectedHead?.objectCode || projectData?.ObjectCode || "N/A",
      );

      formData.append("CRC", selectedHead?.CRC || projectData?.CRC || "N/A");

      // ============================================================
      // AGENCY NAME
      // ============================================================
      formData.append(
        "Agency_Name",
        selectedAgency?.Agency_Name || projectData?.Agency_Name || "N/A",
      );

      // ============================================================
      // GR COPY
      //
      // Only append a file if user selected a NEW file.
      // Backend will preserve old DB file otherwise.
      // ============================================================
    if (file) {
  formData.append("GRCopy", file);
} else if (isEdit && grCopyName) {
  formData.append("GRCopy", grCopyName);
}

      // ============================================================
      // TYPE
      // ============================================================
      if (isEdit) {
        formData.append("type", "updateProjectData");
      } else {
        formData.append("type", "createProject");
      }

      // ============================================================
      // DEBUG
      // ============================================================
      console.log("========== FORM DATA ==========");

      for (const pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      // ============================================================
      // API
      // ============================================================
      const result = await ProjectCreation(formData);

      console.log("PROJECT API RESULT:", result);

      // ============================================================
      // DUPLICATE
      // ============================================================
      if (result?.message === "Project with same name already exists") {
        alert(
          "Project with this name already exists. Please choose another name.",
        );

        setLoading(false);
        return;
      }

      // ============================================================
      // CREATE MAP COORDINATE
      // ============================================================
      // if (!isEdit && result?.ProjectId) {
      //   await CreateMapCoordinateforProject(
      //     "InsertOrUpdateCoordinateforProject",
      //     {
      //       start: locationData.StartCoordinates,
      //       end: locationData.EndCoordinates,
      //       polygon: locationData.PolygonCoordinates,
      //       ProjectId: result.ProjectId,
      //     },
      //   );
      // }

      // 22-09 mapedit
   const savedProjectId = isEdit ? currentProjectId : result?.ProjectId;
if (savedProjectId) {

  await CreateMapCoordinateforProject("InsertOrUpdateCoordinateforProject", {

    start: locationData.StartCoordinates,

    end: locationData.EndCoordinates,

    polygon: locationData.PolygonCoordinates,

    ProjectId: savedProjectId,

  });

}
 

      // ============================================================
      // SUCCESS
      // ============================================================
      if (result?.message) {
        sessionStorage.removeItem("ProjectForm");

        sessionStorage.removeItem("ProjectMapLocation");

        sessionStorage.removeItem("SelectedHead");

        sessionStorage.removeItem("SelectedAgency");

        sessionStorage.removeItem("MapProjectId");

        sessionStorage.removeItem("ProjectTempData");

        sessionStorage.removeItem("GRCopyName");

        tempGRFile = null;

        alert(result.message);

       if (isEdit) {
  sessionStorage.removeItem("keepProjectForm");

  if (onSuccess) {
  
    onSuccess();
  } else {
 
    navigate("/AdminDashboard/ProjectInwardList"); 
  }
} else {
  sessionStorage.removeItem("keepProjectForm");
  window.location.reload();
}
      }
    } catch (err) {
      console.error("Project submit error:", err);

      alert(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Something went wrong while saving project",
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const fetchHeads = async () => {
      try {
        let res = await GetBudgetHeadInfo("null", "all"); // fetch all heads
        setAllHeads(res);
        let res1 = await GetAgencyList();
        setAgency(res1);
        console.log(res1);
      } catch (err) {
        console.log(err);
      }
    };
    fetchHeads();
  }, []);
  // =====================================================
  // EDIT MODE - LOAD PROJECT DATA INTO FORM
  // =====================================================
  // =====================================================
  // EDIT MODE - LOAD PROJECT DATA INTO FORM
  // =====================================================
  // =====================================================
  // EDIT MODE - LOAD COMPLETE PROJECT DATA INTO FORM
  // =====================================================
  useEffect(() => {
    // if (!isEdit || !projectData) {
    //   return;
    // }
// 22-09 mapedit
    if (!isEdit || !projectData || restoredFromMapRef.current) {
  return;
}
// ------
    console.log("========================================");
    console.log("EDIT PROJECT DATA FROM DATABASE");
    console.log("========================================");
    console.log("projectData =", projectData);
    console.log("ProjectId =", projectData.ProjectId);
    console.log("GRNumber =", projectData.GRNumber);
    console.log("GRDate =", projectData.GRDate);
    console.log("GRCopy =", projectData.GRCopy);

    // =====================================================
    // DATE FORMATTER
    // DB:
    // 2026-04-29 18:52:00
    //
    // Picker:
    // Date object
    // =====================================================
    const convertToDate = (value) => {
      if (!value) {
        return null;
      }

      try {
        // Already Date object
        if (value instanceof Date) {
          return isNaN(value.getTime()) ? null : value;
        }

        let dateString = String(value).trim();

        if (!dateString) {
          return null;
        }

        // MySQL datetime:
        // 2026-04-29 18:52:00
        // ->
        // 2026-04-29T18:52:00
        dateString = dateString.replace(" ", "T");

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
          console.log("Invalid date:", value);
          return null;
        }

        return date;
      } catch (error) {
        console.log("Date conversion error:", error);
        return null;
      }
    };

    // =====================================================
    // PROJECT ID
    // =====================================================
    const projectId = projectData.ProjectId ?? projectData.ProjectID ?? "";

    // =====================================================
    // FINANCIAL YEAR
    // =====================================================
    const financialYear = projectData.FinancialYear ?? "";

    // =====================================================
    // PROJECT NAME
    // =====================================================
    const projectName = projectData.ProjectName ?? "";

    // =====================================================
    // PROJECT DETAILS
    // =====================================================
    const projectDetails =
      projectData.ProjectDetails ??
      projectData.Projectdetail ??
      projectData.ProjectDetail ??
      "";

    // =====================================================
    // PIU
    // =====================================================
    const piu = projectData.PIU ?? projectData.piu ?? "";

    // =====================================================
    // AGENCY NAME
    // =====================================================
    const agencyName = projectData.Agency_Name ?? "";

    // =====================================================
    // PROJECT COST
    // =====================================================
    const projectCost = projectData.ProjectCost ?? "";

    // =====================================================
    // PROJECT COMPLETION DATE
    // =====================================================
    const completionDate = projectData.ProjectEstCompletionDate ?? null;

    // =====================================================
    // IMPORTANT:
    // EXACT DATABASE COLUMN = GRNumber
    // =====================================================
    const grNumber = projectData.GRNumber ?? "";

    // =====================================================
    // IMPORTANT:
    // EXACT DATABASE COLUMN = GRDate
    // =====================================================
    const grDate = projectData.GRDate ?? "";

    // =====================================================
    // SCHEME
    // =====================================================
    const scheme = projectData.Scheme ?? "";

    // =====================================================
    // SCHEME TYPE
    // =====================================================
    const schemeType = projectData.SchemeType ?? "";

    // =====================================================
    // GR COPY
    // =====================================================
    const grCopy = projectData.GRCopy ?? "";

    // =====================================================
    // FINAL FORM DATA
    // =====================================================
    const editData = {
      ProjectId: projectId,

      FinancialYear: financialYear,

      ProjectName: projectName,

      Projectdetail: projectDetails,

      piu: piu,

      ProjectCost: projectCost,

      ProjectEstimationCompletionDate: convertToDate(completionDate),

      // IMPORTANT
      //GRNumber: grNumber ? String(grNumber) : "",
      GRNumber:
        grNumber !== null && grNumber !== undefined ? String(grNumber) : "",
      // IMPORTANT
      // Keep Date object for CustomDateTimePicker
      GRDate: convertToDate(grDate),

      Scheme: scheme,

      SchemeType: schemeType,

      GRCopy: typeof grCopy === "string" ? grCopy : "",
    };

    console.log("========================================");
    console.log("FINAL EDIT FORM DATA");
    console.log("========================================");
    console.log(editData);

    console.log("FINAL GR NUMBER =", editData.GRNumber);

    console.log("FINAL GR DATE =", editData.GRDate);

    // =====================================================
    // SET FORM DATA
    // =====================================================
    setData(editData);

    // =====================================================
    // EXISTING GR COPY
    // =====================================================
    if (grCopy) {
      setGrCopyName(String(grCopy));
    } else {
      setGrCopyName("");
    }

    // =====================================================
    // MATCH AGENCY
    // =====================================================
    if (piu && Array.isArray(Agency) && Agency.length > 0) {
      const matchedAgency = Agency.find(
        (agency) => String(agency.Unique_Agency_Code) === String(piu),
      );

      console.log("MATCHED AGENCY =", matchedAgency);

      if (matchedAgency) {
        setSelectedAgency(matchedAgency);
      } else {
        setSelectedAgency(null);
      }
    }

    // =====================================================
    // MATCH BUDGET HEAD
    // =====================================================
    const dbHeadID =
      projectData.HeadID ?? projectData.HeadId ?? projectData.headID ?? "";

    if (dbHeadID && Array.isArray(allHeads) && allHeads.length > 0) {
      const matchedHead = allHeads.find(
        (head) => String(head.HeadID) === String(dbHeadID),
      );

      console.log("MATCHED HEAD =", matchedHead);

      if (matchedHead) {
        setSelectedHead(matchedHead);
      } else {
        setSelectedHead(null);
      }
    } else {
      setSelectedHead(null);
    }
  }, [isEdit, projectData, Agency, allHeads]);
  const handleCancel = () => {
    if (!window.confirm("Are you sure?")) return;
    tempGRFile = null;
    sessionStorage.removeItem("ProjectForm");
    sessionStorage.removeItem("ProjectMapLocation");
    sessionStorage.removeItem("SelectedHead");
    sessionStorage.removeItem("SelectedAgency");
    sessionStorage.removeItem("MapProjectId");
    sessionStorage.removeItem("GRCopyName");
    setGrCopyName("");

    setData({
      FinancialYear: "",
      ProjectName: "",
      Projectdetail: "",
      piu: "",
      ProjectCost: "",
      ProjectEstimationCompletionDate: "",
      GRNumber: "",
      GRDate: "",
      GRCopy: "",
      Scheme: "",
    });

    setLocationData({
      StartCoordinates: [],
      EndCoordinates: [],
      PolygonCoordinates: [],
    });
    setSelectedAgency(null);
    setSelectedHead("");
    setDiableChoosebutton(false);
    if (grCopyRef.current) {
      grCopyRef.current.value = "";
    }
    console.log("delete data cleared");
    console.log("delete data", setData);
  };

  useEffect(() => {
    return () => {
      
      const currentPath = window.location.pathname;
      if (!currentPath.includes("MapFunction")) {
       sessionStorage.removeItem("keepProjectForm");
        sessionStorage.removeItem("ProjectForm");
        sessionStorage.removeItem("ProjectMapLocation");
        sessionStorage.removeItem("SelectedHead");
        sessionStorage.removeItem("SelectedAgency");
        sessionStorage.removeItem("MapProjectId");
        sessionStorage.removeItem("ProjectTempData");
        sessionStorage.removeItem("GRCopy");
        sessionStorage.removeItem("GRCopyName");
      }
    };
  }, []);

  // 22-09 mapedit
  const handleRemoveArea = () => {
  setLocationData({
    StartCoordinates: [],
    EndCoordinates: [],
    PolygonCoordinates: [],
  });
  setDiableChoosebutton(false);
  sessionStorage.removeItem("ProjectMapLocation");
};

  return (
    <>
      <div style={{
    background: "#ffffff",
    width: "100%",
    height: "90vh",
    padding: "30px 24px",
    boxSizing: "border-box",
    fontFamily: "Inter, sans-serif",
    overflowY: "auto",
    scrollbarWidth: "none",
  }}
      >
        <div
          style={{
             display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          background: "transparent",
          padding: "0",
          boxShadow: "none",
          width: "100%",
          marginBottom: "18px",
          marginLeft:"20px"
          }}
        >
          <img
            src={ProjectCreation64}
            style={{
             height: "24px",
              width: "24px",
              objectFit: "contain",
              margin: "0px",
            }}
          ></img>
          <h5
            style={{
             margin: 0,
            color: "black",
            fontWeight: 700,
            fontSize: "22px",
            lineHeight: "1.2",
            }}
          >
            {" "}
            {isEdit ? "Project Update" : "Project Creation"}
          </h5>
        </div>
        {/* <div className="col-12 m-auto my-5 budgetContainer">
            <div className="m-auto budgetElement">
              {loading && (
                <div
                  style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
                    display: 'flex', justifyContent: 'center', alignItems: 'center'
                  }}>
                  <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
                  <style>
                    {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                  </style>
                </div>
              )} */}

        <form
         onSubmit={handleSubmit}
  style={{
    width: "95%",
    maxWidth: "1100px",
    margin: "0 auto",
    boxSizing: "border-box",
  }} >
          <div   style={{
    backgroundColor: "#ffffff",
    padding: "20px",
    borderRadius: "8px",
    width: "100%",
    boxSizing: "border-box",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
  }}
          >
            <div
              style={{
    width: "100%",
    backgroundColor: "#EEF1F6",
    borderRadius: "8px",
    padding: "25px 28px 28px",
    boxSizing: "border-box",
    border: "1px solid #b8dcff",
  }}
            >
              
            <div
              style={{
                display: "grid",
                columnGap: "20px",
                rowGap: "14px",
                width: "100%",
                // margin: "20px 0",
                gridTemplateColumns: "1fr 1fr", // exactly 2 columns
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  className="form-label"
                  style={{
                    fontWeight: "700",
                    marginBottom: "5px",
                    fontSize: "14px",
                    // color: "black",
                  }}
                >
                  Financial Year
                </label>

                <Select
                  options={[
                    { value: "2024-2025", label: "2024 - 2025" },
                    { value: "2025-2026", label: "2025 - 2026" },
                    { value: "2026-2027", label: "2026 - 2027" },
                  ]}
                  value={
                    data.FinancialYear
                      ? {
                          value: data.FinancialYear,
                          label: data.FinancialYear.replace("-", " - "),
                        }
                      : null
                  }
                  onChange={(selected) =>
                    HandleChangeData({
                      target: {
                        name: "FinancialYear",
                        value: selected ? selected.value : "",
                      },
                    })
                  }
                  placeholder="Choose Financial Year"
                  isSearchable
                  isClearable
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "40px",
                      borderRadius: "10px",
                      border: "1px solid #ccc",
                      fontSize: "12px",
                    }),
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <label
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                    marginBottom: "5px",
                    // color: "#111",
                  }}
                >
                  Select Scheme :
                </label>
                <Select
                  options={[
                    { value: "Budget", label: "Budget" },
                    { value: "NonBudget", label: "Non Budget" },
                  ]}
                  value={
                    data.Scheme
                      ? {
                          value: data.Scheme,
                          label:
                            data.Scheme === "NonBudget"
                              ? "Non Budget"
                              : "Budget",
                        }
                      : null
                  }
                  onChange={(selected) => {
                    HandleChangeData({
                      target: {
                        name: "Scheme",
                        value: selected ? selected.value : "",
                      },
                    });

                    if (selected?.value === "NonBudget") {
                      setSelectedHead(null);
                    }
                  }}
                  placeholder="Choose Scheme"
                  isSearchable
                  isClearable
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "40px",
                      borderRadius: "10px",
                      border: "1px solid #ccc",
                      fontSize: "12px",
                    }),
                  }}
                />
              </div>
              {data.Scheme === "Budget" && (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label
                    className="form-label"
                    style={{
                      fontWeight: "600",
                      fontSize: "14px",
                      marginBottom: "5px",
                      // color: "#111",
                    }}
                  >
                    Select Head
                  </label>

                  <Select
                    options={allHeads.map((h) => ({
                      value: h.HeadID,
                      label: h.HeadName,
                    }))}
                    value={
                      selectedHead
                        ? {
                            value: selectedHead.HeadID,
                            label: selectedHead.HeadName,
                          }
                        : null
                    }
                    onChange={(selected) => {
                      const head = allHeads.find(
                        (h) => h.HeadID === selected?.value,
                      );
                      setSelectedHead(head || null);
                    }}
                    placeholder="Choose Head"
                    isSearchable
                    isClearable
                    noOptionsMessage={() => "No head found"}
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: "40px",
                        borderRadius: "10px",
                        border: "1px solid #ccc",
                        fontSize: "12px",
                      }),
                    }}
                  />
                </div>
              )}
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  className="form-label"
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                    marginBottom: "5px",
                    // color: "#111",
                  }}
                >
                  Project Name
                </label>
                <input
                  type="text"
                  placeholder="Enter Project Name"
                  className="form-control py-2"
                  style={{
                     border: "1px solid #c7c0c0",
  borderRadius: "10px",
  padding: "7px 10px",
  width: "100%",
  height: "40px",
  boxSizing: "border-box",
  fontSize: "12px",
                  }}
                  name="ProjectName"
                  value={data.ProjectName}
                  onChange={HandleChangeData}
                  required
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  className="form-label"
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                    marginBottom: "5px",
                    // color: "#111",
                  }}
                >
                  Project Details
                </label>

                <input
                  type="text"
                  placeholder="Enter Project Details"
                  name="Projectdetail"
                  value={data.Projectdetail}
                  style={{
                     border: "1px solid #c7c0c0",
  borderRadius: "10px",
  padding: "7px 10px",
  width: "100%",
  height: "40px",
  boxSizing: "border-box",
  fontSize: "12px",
                  }}
                  onChange={HandleChangeData}
                  required
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  className="form-label"
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                    marginBottom: "5px",
                    // color: "#111",
                  }}
                >
                  Implementing Agency
                </label>

                <Select
                  options={Agency.map((agency) => ({
                    value: agency.Unique_Agency_Code,
                    label: `${agency.Unique_Agency_Code}/${agency.Agency_Name}`,
                  }))}
                  // value={
                  //   data.piu
                  //     ? {
                  //         value: data.piu,
                  //         label:
                  //           Agency.find(
                  //             (a) => a.Unique_Agency_Code === data.piu,
                  //           )?.Unique_Agency_Code +
                  //           "/" +
                  //           Agency.find(
                  //             (a) => a.Unique_Agency_Code === data.piu,
                  //           )?.Agency_Name,
                  //       }
                  //     : null
                  // }
                  // 09-10 
                   value={
                    data.piu
                      ? {
                          value: data.piu,
                          label:
                            Agency.find(
                              (a) => a.Unique_Agency_Code === data.piu,
                            )?.Unique_Agency_Code +
                            "/" +
                            Agency.find(
                              (a) => a.Unique_Agency_Code === data.piu,
                            )?.Agency_Name,
                        }
                      : null
                  }
                  onChange={(selected) => {
                    HandleChangeData({
                      target: {
                        name: "piu",
                        value: selected ? selected.value : "",
                      },
                    });

                    const agency = Agency.find(
                      (a) => a.Unique_Agency_Code === selected?.value,
                    );
                    setSelectedAgency(agency || null);
                  }}
                  placeholder="Choose Agency"
                  isSearchable
                  isClearable
                  noOptionsMessage={() => "No agency found"}
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "40px",
                      borderRadius: "10px",
                      border: "1px solid #ccc",
                      fontSize: "12px",
                    }),
                  }}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  className="form-label"
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                    marginBottom: "5px",
                    // color: "#111",
                  }}
                >
                  Project Cost
                </label>

                {/* <input
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="Enter Project Cost"
                  className="form-control py-2"
                  name="ProjectCost"
                  value={data.ProjectCost}
                  style={{
                    width: "100%",
                    height: "38px",
                    padding: "0 12px",
                    fontSize: "13px",
                    fontWeight: "400",
                    boxSizing: "border-box",
                  }}
                  onChange={HandleChangeData}
                  required
                /> */}
                <input
                  type="text"
                  inputMode="decimal"
                  placeholder="Enter Project Cost"
                  className="form-control py-2"
                  name="ProjectCost"
                  value={
                    data.ProjectCost !== "" && data.ProjectCost != null
                      ? Number(data.ProjectCost).toLocaleString("en-IN", {
                          maximumFractionDigits: 2,
                        })
                      : ""
                  }
                  style={{
                     border: "1px solid #c7c0c0",
  borderRadius: "10px",
  padding: "7px 10px",
  width: "100%",
  height: "40px",
  boxSizing: "border-box",
  fontSize: "12px",
                  }}
                  onChange={(e) => {
                    let value = e.target.value.replace(/,/g, "");

                    // Only numbers + one decimal point, max 2 decimal places
                    if (!/^\d*\.?\d{0,2}$/.test(value)) {
                      return;
                    }

                    HandleChangeData({
                      target: {
                        name: "ProjectCost",
                        value: value,
                      },
                    });
                  }}
                  required
                />
              </div>
              {/* 
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  className="form-label"
                  style={{
                    fontWeight: "600",
                    fontSize: "13px",
                    marginBottom: "5px",
                    color: "#111",
                  }}
                >
                  {" "}
                  Project GR Date{" "}
                </label>
                {/* <div style={{ width: "100%" }}>
                  
                  <CustomDateTimePicker
                    value={data.GRDate ? new Date(data.GRDate) : null}
                    onChange={(newValue) => {
                      HandleChangeData({
                        target: { name: "GRDate", value: newValue },
                      });
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                      },
                      popper: {
                        sx: {
                          "& .MuiPickersLayout-root": {
                            minWidth: "180px",
                            maxWidth: "200px",
                          },
                          "& .MuiPickersCalendarHeader-label": {
                            fontSize: "14px",
                          },
                        },
                      },
                    }}
                  />
                </div> */}

              {/* <input
                  type="datetime-local"
                  name="ProjectEstimationCompletionDate"
                  value={
                    data.ProjectEstimationCompletionDate
                      ? new Date(data.ProjectEstimationCompletionDate)
                          .toISOString()
                          .slice(0, 16)
                      : ""
                  }
                  min={
                    data.GRDate
                      ? new Date(data.GRDate).toISOString().slice(0, 16)
                      : ""
                  }
                  onChange={HandleChangeData}
                  className="form-control py-2"
                  style={{
                    width: "100%",
                    height: "38px",
                    padding: "0 12px",
                    fontSize: "13px",
                    fontWeight: "400",
                    boxSizing: "border-box",
                    border: "1px solid #bdbebe",
                    borderRadius: "5px",
                  }}
                />
              </div>  */}
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  className="form-label"
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                    marginBottom: "5px",
                    // color: "#111",
                  }}
                >
                  Project GR Date
                </label>
{/* 27-10 */}
{/* GR Date */}
<input
  type="datetime-local"
  name="GRDate"
  className="form-control py-2"
  value={toLocalInput(data.GRDate)}
  min={getCurrentDateTime()}
  max="9999-12-31T23:59"
  onChange={handleDateTimeChange}
  style={{
    width: "100%",
    height: "40px",
    borderRadius: "10px",
    border: "1px solid #c7c0c0",
    padding: "7px 10px",
    boxSizing: "border-box",
    fontSize: "12px",
  }}
/>
 
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  className="form-label"
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                    marginBottom: "5px",
                    // color: "#111",
                  }}
                >
                  Project Estimation Completion Date
                </label>

                {/* 27-10 */}
{/* Project Estimation Completion Date */}
<input
  type="datetime-local"
  name="ProjectEstimationCompletionDate"
  className="form-control py-2"
  value={toLocalInput(data.ProjectEstimationCompletionDate)}
  min={toLocalInput(data.GRDate) || getCurrentDateTime()}
  max="9999-12-31T23:59"
  onChange={handleDateTimeChange}
  style={{
    width: "100%",
    height: "40px",
    borderRadius: "10px",
    border: "1px solid #c7c0c0",
    padding: "7px 10px",
    boxSizing: "border-box",
    fontSize: "12px",
  }}
/>
 
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  className="form-label"
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                    marginBottom: "5px",
                    // color: "#111",
                  }}
                >
                  GR Number
                </label>
                <input
                  type="text"
                  placeholder="Enter GR Number"
                  className="form-control py-2"
                  name="GRNumber"
                  value={data.GRNumber || ""}
                  onChange={HandleChangeData}
                  style={{
                    border: "1px solid #c7c0c0",
  borderRadius: "10px",
  padding: "7px 10px",
  width: "100%",
  height: "40px",
  boxSizing: "border-box",
  fontSize: "12px",
                  }}
                  required
                />
              </div>

              {/* <div style={{ display: "flex", flexDirection: "column" }}>
                <label
                  className="form-label"
                  style={{
                    fontWeight: "600",
                    fontSize: "13px",
                    marginBottom: "5px",
                    color: "#111",
                  }}
                >
                  {" "}
                  Project GR Copy{" "}
                </label>
                <input
                  type="file"
                  name="GRCopy"
                  id="GRCopy"
                  ref={grCopyRef}
                  className="form-control py-2"
                  style={{
                    width: "100%",
                    height: "38px",
                    padding: "0 12px",
                    fontSize: "13px",
                    fontWeight: "400",
                    boxSizing: "border-box",
                  }}
                  onChange={HandleChangeData}
                />
                {grCopyName && (
                  <div
                    style={{
                      marginTop: "5px",
                      color: "green",
                      fontWeight: "600",
                    }}
                  >
                    Selected GR Copy: {grCopyName}
                  </div>
                )}
              </div> */}
              <div style={{ display: "flex", flexDirection: "column" }}>
  <label
    className="form-label"
    style={{
      fontWeight: "600",
      fontSize: "14px",
      marginBottom: "5px",
      // color: "#111",
    }}
  >
    Project GR Copy
  </label>

  {/* File input for NEW file */}
  <input
    type="file"
    name="GRCopy"
    id="GRCopy"
    ref={grCopyRef}
    className="form-control py-2"
    style={{
      border: "1px solid #c7c0c0",
  borderRadius: "10px",
  padding: "7px 10px",
  width: "100%",
  height: "40px",
  boxSizing: "border-box",
  fontSize: "12px",
    }}
    onChange={HandleChangeData}
  />

  {/* EXISTING FILE in EDIT mode */}
  {isEdit && grCopyName && (
    <div
      style={{
        marginTop: "6px",
        padding: "7px 10px",
        backgroundColor: "#f0f8ff",
        border: "1px solid #c8dff5",
        borderRadius: "5px",
        fontSize: "12px",
      }}
    >
      <strong>Existing GR Copy:</strong>{" "}

    <a
      href={`${apiurl}/ProjectDocsImages/${encodeURIComponent(grCopyName)}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#007bff",
        textDecoration: "underline",
        cursor: "pointer",
      }}
    >
        {grCopyName}
      </a>
    </div>
  )}

  {/* NEW FILE selected */}
  {!isEdit && grCopyName && (
    <div
      style={{
        marginTop: "5px",
        color: "green",
        fontWeight: "600",
      }}
    >
      Selected GR Copy: {grCopyName}
    </div>
  )}
</div>
              <div className="row mb-3 align-items-start">
                {/* Label */}
                <div
                  style={{
                    gridColumn: "1 / -1",
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <label
                    className="form-label"
                    style={{
                      fontWeight: "600",
                      fontSize: "14px",
                      marginBottom: "5px",
                      // color: "#111",
                    }}
                  >
                    Choose Area <span className="text-danger">*</span>
                  </label>
                </div>

                {/* Button / Coordinates */}
                {/* <div className="col-md-7">
                  {diableChoosebutton ? (
                    <div
                      style={{
                        width: "180%",
                        minHeight: "38px",
                        border: "1px solid #bfc8d2",
                        borderRadius: "6px",
                        backgroundColor: "#ffffff",
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        boxSizing: "border-box",
                        padding: "6px 8px",
                        gap: "8px 15px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          minWidth: 0,
                          maxWidth: "100%",
                          overflowWrap: "anywhere",
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        <strong>Start:</strong> (
                        {locationData?.StartCoordinates?.[0]},{" "}
                        {locationData?.StartCoordinates?.[1]})
                      </div>

                      <div
                        style={{
                          minWidth: 0,
                          maxWidth: "100%",
                          overflowWrap: "anywhere",
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        <strong>End:</strong> (
                        {locationData?.EndCoordinates?.[0]},{" "}
                        {locationData?.EndCoordinates?.[1]})
                      </div>
                    </div>
                  ) : (
                    <button
                      type="button"
                      className="w-100 d-flex align-items-center justify-content-center gap-3"
                      onClick={navigatetoMap}
                      style={{
                        height: "30px",
                        minWidth: "220px",
                        borderRadius: "5px",
                        border: "1px solid #bfc8d2",
                        backgroundColor: "#e5e9ee",
                        color: "#2c3e50",
                        fontWeight: "600",
                        fontSize: "11px",
                        cursor: "pointer",
                        padding: "0 15px",
                        flexShrink: 0,
                      }}
                    >
                      <span>Choose Area</span>
                    </button>
                  )}
                </div> */}
                {/* 22-09 mapedit */}
      <div className="col-md-7">

  {diableChoosebutton ? (
<div

      style={{

        display: "flex",

        alignItems: "center",

        minHeight: "38px",

        border: "1px solid #bfc8d2",

        borderRadius: "6px",

        backgroundColor: "#ffffff",

        flexWrap: "wrap",

        boxSizing: "border-box",

        padding: "6px 8px",

        gap: "8px 15px",

        overflow: "hidden",

        width: "100%",

        maxWidth: "480px",

      }}
>
<div style={{ overflowWrap: "anywhere" }}>
<strong>Start:</strong> ({locationData?.StartCoordinates?.[0]},{" "}

        {locationData?.StartCoordinates?.[1]})
</div>
<div style={{ overflowWrap: "anywhere" }}>
<strong>End:</strong> ({locationData?.EndCoordinates?.[0]},{" "}

        {locationData?.EndCoordinates?.[1]})
</div>
 
      <button

        type="button"

        onClick={handleRemoveArea}

        title="Remove selected area"

        style={{

          marginLeft: "auto",

          border: "none",

          background: "transparent",

          color: "#f03928",

          fontWeight: "700",

          fontSize: "18px",

          lineHeight: 1,

          cursor: "pointer",

          padding: "0 6px",

        }}
>

        ✕
</button>
</div>

  ) : (
<button

      type="button"

      className="w-100 d-flex align-items-center justify-content-center gap-3"

      onClick={navigatetoMap}

      style={{

        height: "30px",

        minWidth: "220px",

        borderRadius: "5px",

        border: "1px solid #bfc8d2",

        backgroundColor: "#e5e9ee",

        color: "#2c3e50",

        fontWeight: "600",

        fontSize: "11px",

        cursor: "pointer",

        padding: "0 15px",

        flexShrink: 0,

      }}
>
<span>Choose Area</span>
</button>

  )}
</div>
 
 

              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
                marginTop: "20px",
                // marginRight: "60px",
                width: "100%",
              }}
            >
              <button
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  width: "120px",
                  height: "40px",
                  border: "none",
                  borderRadius: "20px",
 //30/10
                 backgroundColor:" rgb(46, 158, 79)",                  color: "#ffffff",
                  fontSize: "14px",
                  fontWeight: "700",
                  cursor: "pointer",
                  boxSizing: "border-box",
                }}
                onClick={handleSubmit}
              >
                <img
                  src={submit}
                  style={{
                    // marginRight: "10px",
                    width: "18px",
                    height: "18px",
                    objectFit: "contain",
                  }}
                />
                {loading ? "Saving..." : isEdit ? "Update" : "Save"}
              </button>
              <button
                type="button"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "20px",
                  width: "120px",
                  height: "40px",
                  backgroundColor: "#f03928",
                  border: "none",
                  fontSize: "16px",
                  color: "#ffffff",
                  fontWeight: "700",
                  cursor: "pointer",
                }}
                onClick={handleCancel}
              >
                {" "}
                <img
                  src={Cancel32}
                  style={{ marginRight: "10px", width: "1.2rem" }}
                  alt=""
                />{" "}
                Cancel{" "}
              </button>
            </div>
          </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default CreateProject;

